<template>
    <v-form v-model="valid" ref="form" @submit.prevent="submit" :disabled="isLoading" class="ma-0 pa-0">
        <v-row no-gutters>
            <v-col cols="12">
                <h2>{{ $t('servicesystem.common_objects.contract.operation') }}</h2>
            </v-col>
            <v-col cols="6">
                <!-- Selection wether its Add or Delete -->
                <QButtonGroup noempty :label="$t('servicesystem.common_objects.contract.operation')"
                    v-model="options.OperationMode" :list="priceChangeOperationModes" @change="resetValidation();">
                </QButtonGroup>
            </v-col>
            <template v-if="options.OperationMode === 'add'">
                <v-col cols="6" class="my-auto">
                    <QButtonGroup :label="$t('servicesystem.common_objects.contract.price-change-type')" v-model="options.PriceMode" @change="resetValidation();"
                        :list="priceValueModes" noempty>
                    </QButtonGroup>
                </v-col>
                <v-col cols="6" style="margin-top: 2px;">
                    <QDateField :label="$t('servicesystem.common_objects.contract.price-from')" :hidedetails="false" v-model="options.PriceDate" :min="null"
                        :max="null" externaledit>
                    </QDateField>
                </v-col>
                <v-col cols="6" class="ma-auto" v-if="options.PriceMode === 'dynamic'">
                    <v-text-field :validate-on-blur="false" :rules="[...noEmptyRule, ...notZeroRule]" type="number"
                        label="%" v-model.number="options.DynamicPricingPercentage"></v-text-field>
                </v-col>
                <v-col v-else cols="6" class="ma-auto">
                    <v-text-field :validate-on-blur="false" :rules="[...noEmptyRule, ...notZeroRule]" type="number"
                        :label="$t('servicesystem.common_objects.contract.fixed-price')" v-model.number="options.FixedPrice"></v-text-field>
                </v-col>
            </template>
            <template v-else>
                <v-col cols="12">
                    <QDateField class="mb-2" :label="$t('servicesystem.common_objects.contract.date-after')" v-model="options.PriceDate" :min="null" :max="null"
                        externaledit>
                    </QDateField>
                </v-col>
            </template>
            <v-col cols="auto">
                <QButtonGroup dense :label="$t('servicesystem.common_objects.contract.invoice-comment')" v-model="options.InvoiceCommentMode"
                    :list="InvoiceCommentModes" class="mr-2">
                </QButtonGroup>
            </v-col>
            <v-col cols="auto">
                <QInfo :text="invoiceCommentInfo" />
            </v-col>
            <v-col cols="ma-auto" class="ma-auto" align="right">
                <v-btn color="primary" type="submit" :disabled="isLoading">
                    {{ $t('servicesystem.common_objects.contract.run') }}</v-btn>
            </v-col>
            <v-col cols="12">
                <v-textarea auto-grow :rows="1" :row-height="12" v-if="options.InvoiceCommentMode === 'set'"
                    v-model="options.InvoiceComment" dense hide-details :disabled="options.InvoiceCommentMode == null"
                    class="invoice-comment-text-area"></v-textarea>
            </v-col>
            <v-col cols="12">
                <v-progress-linear :value="taskProgress" class="my-2" v-if="isLoading" :height="25"
                    color="success"></v-progress-linear>
            </v-col>
        </v-row>
    </v-form>
</template>

<script>
import QButtonGroup from "@/components/Inputs/QButtonGroup.vue";
import QDateField from "@/components/Inputs/QDateField3.vue";
import QInfo from "@/components/QInfo.vue";
import RuleMixin from "@/helpers/Mixins/RuleMixin";
export default {
    name: "ContractDetailPriceUpdateOperationControl",
    mixins: [RuleMixin],
    components: {
        QDateField,
        QButtonGroup,
        QInfo
    },
    props: {
        options: {
            type: Object,
            required: true
        },
        isLoading: {
            type: Boolean,
            required: true
        },
        taskProgress: {
            type: [Number, null],
            required: true
        }
    },
    data() {
        return {
            invoiceCommentInfo: this.$t('servicesystem.common_objects.contract.invoice-comment-info'),
            valid: false,
            priceChangeOperationModes: [
                { text: this.$t('servicesystem.common_objects.contract.add'), value: 'add' },
                { text: this.$t('servicesystem.common_objects.contract.remove'), value: 'remove' },
            ],
            priceValueModes: [
                { text: this.$t('servicesystem.common_objects.contract.fixed'), value: 'fixed' },
                { text: this.$t('servicesystem.common_objects.contract.dynamic'), value: 'dynamic' },
            ],
            InvoiceCommentModes: [
                { text: this.$t('servicesystem.common_objects.contract.none'), value: 'none' },
                { text: this.$t('servicesystem.common_objects.contract.set-invoice-comment'), value: 'set' },
                { text: this.$t('servicesystem.common_objects.contract.clear'), value: 'clear' },
            ],
        }
    },
    methods: {
        submit() {
            if (this.$refs.form.validate()) {
                this.$emit('run');
            }
        },
        resetValidation() {
            if (this.$refs.form) {
                this.$refs.form.resetValidation();
            }
        },
    },
    watch: {
        options: {
            handler() {
                this.resetValidation();
            },
            deep: true
        }
    }
}
</script>

<style scoped>
.invoice-comment-text-area ::v-deep textarea {
    line-height: 1.2 !important;
    min-height: 16px !important;
}
</style>